// extracted by mini-css-extract-plugin
export var circle = "_39-2";
export var icon = "_39-a";
export var iconHighlight = "_39-0";
export var lg = "_39-8";
export var md = "_39-7";
export var outline = "_39-4";
export var sm = "_39-6";
export var square = "_39-1";
export var xl = "_39-9";
export var xs = "_39-5";
export var xxs = "_39-3";